"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceChange = void 0;
var _definitions = require("@ppay/definitions");
var _decimal = _interopRequireDefault(require("decimal.js"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _ticker = require("../../../ticker");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var P = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n  font-size: 14px;\n"])));
var Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return theme.colors[color];
});
var PriceChange = function PriceChange(props) {
  var decimalChange = new _decimal.default(props.change);
  var isPercentPositive = new _decimal.default(props.changePercent).gte(0);
  var isChangePositive = new _decimal.default(props.change).gte(0);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: props.className,
    color: isPercentPositive ? 'success' : 'danger'
  }, !props.showOnlyPercent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(P, null, isChangePositive ? '+' : '-', /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: _definitions.Ticker.USD
  }), /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    ticker: _definitions.Ticker.USD,
    value: decimalChange.abs().toString()
  })), /*#__PURE__*/_react.default.createElement(P, null, "(", isPercentPositive && '+', /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    value: props.changePercent,
    decimals: 2
  }), "%)")) : /*#__PURE__*/_react.default.createElement(P, null, isPercentPositive && '+', /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    value: props.changePercent,
    decimals: 2
  }), "%"));
};
exports.PriceChange = PriceChange;